import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { brandActions } from '../../../store/modules/brand';
import {
  CANCEL_LIMIT_RADIO_LIST,
  CONSUMER_INJURY_RADIO_LIST,
  DELIVERY_DELAY_RADIO_LIST,
  EXCHANGE_REFUND_GUARANTEE_RADIO_LIST,
  REFUND_BY_SELLER_RADIO_LIST,
} from '../../../constants/service/app/productRegisterConstants';

export const useBrandDetailProductRegister = (storeId, form) => {
  const dispatch = useDispatch();

  // redux store에서 브랜드 상품등 정보 조회
  const selectBrandProductRegister = (state) => state.brand.brandDetail.productRegister;
  const brandDetailProductRegisterInfo = useSelector(selectBrandProductRegister);

  // 마운트시에 기본옵션 적용하여 브랜드 상품등록 정보 불러오기
  useEffect(() => {
    dispatch(brandActions.getBrandDetailProductRegister({ storeId }));
  }, [storeId, dispatch]);

  /**
   * @name onSubmitEditProductRegisterInfo
   * @description [브랜드 상세] 상품등록 편집
   * @param {SubmitEvent} e
   *
   * @returns void
   * */
  const onSubmitEditProductRegisterInfo = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll({ scroll: { offsetTop: 150, offsetBottom: 150 } }, (err, values) => {
      if (!err) {
        dispatch(
          brandActions.editBrandProductRegister({
            storeId,
            tradingConditionsInfo: {
              refundBySeller: values.refundBySellermanual
                ? values.refundBySellermanual
                : REFUND_BY_SELLER_RADIO_LIST.find((list) => list.id === values.refundBySeller).name,
              cancelLimit: values.cancelLimitmanual
                ? values.cancelLimitmanual
                : CANCEL_LIMIT_RADIO_LIST.find((list) => list.id === values.cancelLimit).name,
              exchangeRefundGuarantee: values.exchangeRefundGuaranteemanual
                ? values.exchangeRefundGuaranteemanual
                : EXCHANGE_REFUND_GUARANTEE_RADIO_LIST.find((list) => list.id === values.exchangeRefundGuarantee).name,
              deliveryDelay: values.deliveryDelaymanual
                ? values.deliveryDelaymanual
                : DELIVERY_DELAY_RADIO_LIST.find((list) => list.id === values.deliveryDelay).name,
              consumerInjury: values.consumerInjurymanual
                ? values.consumerInjurymanual
                : CONSUMER_INJURY_RADIO_LIST.find((list) => list.id === values.consumerInjury).name,
            },
            addDeliveryChargeInfo: {
              deliveryChargeReturn: values.deliveryChargeReturn,
              deliveryChargeJeju: values.deliveryChargeJeju,
              deliveryChargeEtc: values.deliveryChargeEtc,
            },
            deliveryInfo: {
              originAddress: {
                ...values.originAddress,
                memo: values.additionalDeliveryInfo,
                line2: values.originAddressLine2,
              },
              returnAddress: {
                ...values.returnAddress,
                memo: values.refundExchangeInfo,
                line2: values.returnAddressLine2,
              },
              takebackInfo: {
                useAutoTakeback: values.useAutoTakeback,
                deliveryEnterpriseId: values.deliveryEnterpriseId,
                cusCde: values.cusCde,
                comDivCde: values.comDivCde,
                takebackPaymentType: values.takebackPaymentType,
                takebackSizeType: values.takebackSizeType,
              },
            },
            afterServiceInfo: {
              asPhone: values.asPhone,
              kakaoAccount: values.kakaoAccount,
              asInform: values.asInform,
              caution: values.caution,
              qualityAssurance: values.qualityAssurance,
              manufacturer: values.manufacturer,
              origin: values.origin,
            },
          }),
        );
      }
    });
  };

  return { onSubmitEditProductRegisterInfo, brandDetailProductRegisterInfo };
};
